import { render, staticRenderFns } from "./form-forget.vue?vue&type=template&id=3852d38f&scoped=true&"
import script from "./form-forget.vue?vue&type=script&lang=js&"
export * from "./form-forget.vue?vue&type=script&lang=js&"
import style0 from "./form-forget.vue?vue&type=style&index=0&id=3852d38f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/172.26.59.72+4873+vue-loader@15.10.1_6sfbhgu6kjcmlhpjwryimz4q4m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3852d38f",
  null
  
)

export default component.exports